import React from 'react';
import { useIntl } from 'react-intl';

import Checkbox from '@/components/switchback/Checkbox/Checkbox';
import { ROTATE_CW } from '@/components/switchback/Icon/assets';
import Icon from '@/components/switchback/Icon/IconComponent';
import Loading from '@/components/switchback/Loading/Loading';

import css from './ToggleSearch.module.css';

interface IProps {
  checked: boolean;
  loading: boolean;
  onChange: React.ChangeEventHandler;
  onClick: () => void;
}

const ToggleSearch: React.FC<IProps> = ({ checked, loading, onChange, onClick }) => {
  const intl = useIntl();

  return (
    <>
      {/* Tablet and below. */}
      <button
        className={`${css.button} before-focus-style`}
        data-loading={String(loading)}
        data-testid="search-map-button"
        onClick={onClick}>
        <span className={css.label}>
          <Icon aria-hidden className="mr-3" name={ROTATE_CW} height={16} width={16} />
          {intl.formatMessage({
            defaultMessage: 'Search this area',
            id: 'DCFPf/',
            description:
              'Search (tablet and below): button label to trigger new search based on map view',
          })}
        </span>
        <span className={css.loading} data-testid="loading">
          <Loading />
        </span>
      </button>

      {/* Desktop and above. */}
      <div className={css.wrapper}>
        <Checkbox
          checked={checked}
          data-testid={`search-map-checkbox-${String(checked)}`}
          name="map-dynamic-search-checkbox"
          onChange={onChange}>
          <span className="font-medium text-gray-900 autoType200">
            {intl.formatMessage({
              defaultMessage: 'Search as I move the map',
              id: 'e/Tag5',
              description:
                'Search (desktop and above): button label to trigger new search based on map view',
            })}
          </span>
        </Checkbox>
      </div>
    </>
  );
};

export default ToggleSearch;
